import { navigateTo } from '../../../common/frontend/route-utils.js'
import './portal-banner.css'

export interface PortalBannerProps {
    text: string
    deadline?: string
    /** Optional call to action; omitted for purely informational strips. */
    ctaLabel?: string
    ctaUrl?: string
}

/**
 * Full-width callout strip at the top of the dashboard body — currently used
 * for an open Q12 survey period. Purely presentational: all copy and the
 * target URL come in as props.
 */
export const PortalBanner = ({ text, deadline, ctaLabel, ctaUrl }: PortalBannerProps) => (
    <div className="portal-banner" role="note">
        <span className="portal-banner__text">
            {text}
            {deadline ? <span className="portal-banner__deadline">{deadline}</span> : null}
        </span>
        {ctaLabel && ctaUrl ? (
            <button type="button" className="portal-banner__cta" onClick={() => navigateTo(ctaUrl)}>
                {ctaLabel}
            </button>
        ) : null}
    </div>
)
